import { render, staticRenderFns } from "./PvcStickers.vue?vue&type=template&id=3070ecec&scoped=true&"
import script from "./PvcStickers.vue?vue&type=script&lang=js&"
export * from "./PvcStickers.vue?vue&type=script&lang=js&"
import style0 from "./PvcStickers.vue?vue&type=style&index=0&id=3070ecec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070ecec",
  null
  
)

component.options.__file = "PvcStickers.vue"
export default component.exports